/**
 * Source UNIQUE des tons de badge de statut + formatteurs montant/date.
 *
 * Le backend (projection unique `transaction_state`) renvoie `status_label` +
 * `status_tone` (une clé parmi emerald/amber/red/slate/blue). Chaque écran qui
 * affiche un statut de transaction (Mes ventes, Mes achats, Mes locations, Mes
 * offres, dashboard asso…) doit mapper ce ton AVEC LA MÊME palette — sinon le
 * même état apparaît en 3 verts différents selon la page (incohérence relevée à
 * l'audit de finition). La palette de référence est celle de « Mes ventes »
 * (SalesPage, écran le plus abouti) : on l'a figée ici pour que TOUT s'aligne.
 */

// Ton → classes Tailwind (fond + texte), forme « plate » prête pour `className`.
export const TONE_CLS = {
  emerald: "bg-emerald-50 text-emerald-700",
  amber: "bg-amber-50 text-amber-700",
  red: "bg-red-50 text-red-700",
  slate: "bg-slate-100 text-slate-600",
  blue: "bg-blue-50 text-blue-700",
};

// Classes d'un ton (repli slate neutre si ton inconnu — jamais de classe vide).
export function toneClasses(tone) {
  return TONE_CLS[tone] || TONE_CLS.slate;
}

// Montant en euros, format FR homogène (« 12,50 € », séparateur virgule). 0/NaN → « 0,00 € ».
export const fmtEur = (n) =>
  `${(Number(n) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

// Date courte FR ; valeur absente → tiret cadratin (jamais « Invalid Date »).
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");
